import * as React from 'react';
import './Message.scss';

type message = 'empty' | 'error' | 'unknown';

interface IMessage {
  type: message;
  title?: string;
}

const DEFAULTS = {
  empty: {
    title: 'This is the default title.',
    content: 'This is the default body.',
  },
  error: {
    title: 'This is the default title.',
    content: 'This is the default body.',
  },
  unknown: {
    title: 'default something unknown happened',
    content: 'default something unknown happened',
  },
};

export const Message: React.FC<IMessage> = ({
  type,
  title,
  children: content,
}) => {
  return (
    <div id={`${type}-message`} className='py-5'>
      <div id='title'>{title ? title : DEFAULTS[type].title}</div>
      <div id='body'>{content ? content : DEFAULTS[type].content}</div>
    </div>
  );
};
